import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Colors from '../common/NekoTheme';

const ToolbarBase = Styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  padding: 10px 10px;
  background: ${Colors.white};
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(${Colors.blackRGB}, 0.1);
  align-items: center;

  &.neko-align-left {
    justify-content: flex-start;
  }

  &.neko-align-right {
    justify-content: flex-end;
  }

  > *:not(:last-child) {
    margin-right: 5px;
  }
`;

const StyledNekoToolbar = ({ align = 'left', ...props }) => {
  return (
    <ToolbarBase className={`neko-align-${align}`} {...props}>
      {props.children}
    </ToolbarBase>
  );
};

const NekoToolbar = (props) => {
  return (<StyledNekoToolbar {...props} />);
};

NekoToolbar.propTypes = {
  align: PropTypes.oneOf(['left', 'right'])
};

NekoToolbar.defaultProps = {
  align: 'left'
};

export { NekoToolbar };